<template>
  <div>
    <loading v-show="showLoader" />

    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'Home' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div style="padding-top: 77px;">
              <h2 class="listing-page-title">Contact Us</h2>
              <p class="listing-page-desc">Insurance Bazaar</p>
            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img
              class="img-fluid"
              alt="icon"
              :src="require('@/assets/images/claim-policy-right-img.svg')"
            />
          </div>
        </div>
      </div>
    </div>
    <contactHomeSection />
  </div>
</template>

<script>
  import contactHomeSection from '@/components/Contact/ContactHomeSection'

  export default {
    name: 'ContactUs',
    components: {
      contactHomeSection
    },
    data () {
      return {
        showLoader: false
      }
    }
  }
</script>

<style scoped>
  h1 {
    font-family: "Futura PT";
    font-size: 30px;
    font-weight: 900;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.27;
    letter-spacing: normal;
    text-align: left;
    color: #ba0c2f;
    margin-bottom: 0rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/ContactUs.vue